module.exports = __webpack_public_path__ + "media/components/assets/img/pic/avatar/julia-f196185f912561883dab9668dc57ae06.jpg";